import { useContext } from 'react'

import AureusDeboostContext, {
  AureusDeboostContextType,
} from '@contexts/aureusDeboostContext'

const DEFAULT_CONTEXT_VALUE = {
  deboostOnClick: () => {},
}

const useAureusDeboost = (): AureusDeboostContextType =>
  useContext(AureusDeboostContext) ?? DEFAULT_CONTEXT_VALUE

export default useAureusDeboost
